import { AutogenModelManifestProfile, AutogenRowManifestProfile } from "./autogen/AutogenModelManifestProfile";

export class ModelManifestProfile extends AutogenModelManifestProfile<RowManifestProfile> {
	constructor() {
		super(RowManifestProfile);
	}
}

export class RowManifestProfile extends AutogenRowManifestProfile {
}